"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DirectionalHint_1 = require("../../common/DirectionalHint");

exports.DirectionalHint = DirectionalHint_1.DirectionalHint;
/**
 * {@docCategory ContextualMenu}
 */

var ContextualMenuItemType;

(function (ContextualMenuItemType) {
  ContextualMenuItemType[ContextualMenuItemType["Normal"] = 0] = "Normal";
  ContextualMenuItemType[ContextualMenuItemType["Divider"] = 1] = "Divider";
  ContextualMenuItemType[ContextualMenuItemType["Header"] = 2] = "Header";
  ContextualMenuItemType[ContextualMenuItemType["Section"] = 3] = "Section";
})(ContextualMenuItemType = exports.ContextualMenuItemType || (exports.ContextualMenuItemType = {}));